/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import H3Image from '@Uilib/h3Image';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import H3Text from '@Uilib/h3Text';
import ProductActions from '@Actions/productActions';
import imageDefault from '@Images/icons/imageDefault.png';
import Helpers from '@Apis/helpers';
import { QUANTITY } from '@Apis/constants';
import { Select } from 'antd';
import './style.scss';

const { Option } = Select;

/**
 * TenantSkuFilter custom component
 *
 */
class TenantSkuFilter extends Component {
  /**
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      showSuggestions: false,
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      record, handleProductChangeValue, products, user, getProducts, handleProductChange, showError, disabled, isTextarea, onClear, tenantDepartmentId, onlyBatches,
      excludedProducts, excludeOutOfStock, isSalesProduct, isPurchaseProduct, includeService, showClear, excludeService, excludedBundledProducts, excludedNonStorableProducts,
      includeBundle, selectedTenant, isMarketplaceSeller, productType, searchProducts, searchProductsLoading, searchResults,
    } = this.props;
    const { showSuggestions } = this.state;
    const getSearchProducts = onlyBatches ? products?.result?.products?.filter((product) => product?.product_batches) : products?.result?.products;
    return (
      <div
        className={`create-pr__product-name__wrapper ${showError ? 'create-pr__input' : ''}`}
        onBlur={() => {
          setTimeout(() => this.setState({ showSuggestions: false }), 300);
        }}
      >
        {
          isTextarea ? (
            <React.Fragment>

              <textarea
                value={record.product_sku_name}
                className="orgFormInput orgFormTextarea"
                onChange={(e) => {
                  handleProductChangeValue(e.target.value, record.key);
                  searchProducts({
                    keyword: e.target.value.toLowerCase(),
                    tenantId: selectedTenant || user?.tenant_info?.tenant_id,
                    stockStatus: null,
                    page: 1,
                    limit: 10,
                    tenantDepartmentId: tenantDepartmentId || '',
                    excludeOutOfStock,
                    productType: null,
                    category: null,
                    isSalesProduct,
                    isPurchaseProduct,
                    search: true,
                  });
                  this.setState({ showSuggestions: true });
                }}
                onFocus={() => {
                  searchProducts({
                    keyword: '',
                    tenantId: selectedTenant || user?.tenant_info?.tenant_id,
                    stockStatus: null,
                    page: 1,
                    limit: 10,
                    tenantDepartmentId: tenantDepartmentId || '',
                    excludeOutOfStock,
                    productType: null,
                    category: null,
                    isSalesProduct,
                    isPurchaseProduct,
                    search: true,
                  });
                  this.setState({ showSuggestions: true });
                }}
                disabled={disabled || record?.sku || record?.tenant_product_id || showClear}
                rows={2}
              />
              <div style={{ display: 'flex' }}>
                {(record?.sku || record?.tenant_product_id || showClear) && (
                  <H3Text
                    onClick={() => {
                      onClear(record.key);
                    }}
                    text={<div>Clear</div>}
                    className="table-subscript"
                  />
                )}
                {record?.product_type === 'BUNDLE' && <H3Text text="Bundle" className="table-subscript__product-type" />}
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <input
                value={record.product_sku_name}
                className="orgFormInput"
                onChange={(e) => {
                  handleProductChangeValue(e.target.value, record.key);
                  searchProducts({
                    keyword: e.target.value.toLowerCase(),
                    tenantId: selectedTenant || user?.tenant_info?.tenant_id,
                    stockStatus: null,
                    page: 1,
                    limit: 10,
                    tenantDepartmentId: tenantDepartmentId || '',
                    excludeOutOfStock,
                    productType: null,
                    category: null,
                    isSalesProduct,
                    isPurchaseProduct,
                    search: true,
                  });
                  this.setState({ showSuggestions: true });
                }}
                onFocus={() => {
                  searchProducts({
                    keyword: '',
                    tenantId: selectedTenant || user?.tenant_info?.tenant_id,
                    stockStatus: null,
                    page: 1,
                    limit: 10,
                    tenantDepartmentId: tenantDepartmentId || '',
                    excludeOutOfStock,
                    productType: null,
                    category: null,
                    isSalesProduct,
                    isPurchaseProduct,
                    search: true,
                  });
                  this.setState({ showSuggestions: true });
                }}
                disabled={disabled || record?.sku || record?.tenant_product_id || showClear}
              />
              <div style={{ display: 'flex' }}>
                {(record?.sku || record.tenant_product_id || showClear) && (
                  <H3Text
                    onClick={() => {
                      onClear(record.key);
                    }}
                    text={<div>Clear</div>}
                    className="table-subscript"
                  />
                )}
                {(record?.product_type === 'BUNDLE' && showClear) && <H3Text text="Bundle" className="table-subscript__product-type" />}
              </div>
            </React.Fragment>
          )
        }
        {products && products?.result?.products && products?.result?.products.length > 0 && showSuggestions && (
          <div className="create-pr__product-name__suggestions">
            <div className="create-pr__product-name__suggestion-items">
              {getSearchProducts
                ?.filter((item) => (productType ? productType === item?.product_type?.toUpperCase() : true))
                ?.filter((item) => (excludeService ? item?.product_type?.toUpperCase() !== 'SERVICE' : true))
                ?.filter((item) => (!isMarketplaceSeller ? !item?.is_marketplace_product : true))
                ?.filter((item) => !excludedProducts?.includes(JSON.stringify(item?.tenant_product_id)))
                ?.filter((item) => (excludeOutOfStock
                  ? includeService
                    ? includeBundle
                      ? (item?.available_qty > 0 || item?.product_type?.toUpperCase() === 'BUNDLE' || item?.product_type?.toUpperCase() === 'SERVICE')
                      : (item?.available_qty > 0 || item?.product_type?.toUpperCase() === 'SERVICE')
                    : includeBundle
                      ? (item?.available_qty > 0 || item?.product_type?.toUpperCase() === 'BUNDLE')
                      : item?.available_qty > 0 : true))
                ?.filter((item) => (excludedBundledProducts ? item?.product_type?.toUpperCase() !== 'BUNDLE' : true))
                ?.filter((item) => (excludedNonStorableProducts ? item?.product_type?.toUpperCase() !== 'NON_STORABLE' : true))
                .map((item) => (
                  <div key={item.product_sku_id}>
                    <div
                      className="create-pr__product-name__suggestion-item"
                      onClick={() => {
                        handleProductChange(item, record.key);
                        this.setState({ showSuggestions: false });
                      }}
                    >
                      { item?.product_info?.assets?.[0]?.url
                        ? (
                          <H3Image
                            src={`${item?.product_info?.assets?.[0]?.url}`}
                            className="create-pr__product-name__suggestion-item__image"
                          />
                        )
                        : (
                          <H3Image
                            src={imageDefault}
                            className="create-pr__product-name__suggestion-item__image__default"
                          />
                        )}

                      <div>
                        <H3Text
                          text={`${item?.product_info?.product_sku_name}`}
                          className="create-pr__product-name__suggestion-item__text"
                        />
                        {item?.product_type?.toUpperCase() !== 'SERVICE' && (
                          <div
                            className="create-pr__product-name__suggestion-item__qty"
                            style={{
                            // eslint-disable-next-line no-nested-ternary
                              backgroundColor: item?.available_qty > 0 && item?.available_qty >= item?.threshold_qty ? 'green' : item?.available_qty < item?.threshold_qty && item?.available_qty > 0 ? '#2D7DF7' : 'red',
                            }}
                          >
                            {`${QUANTITY(item?.available_qty, item?.uom_info?.precision)} ${item?.uom_info?.uqc?.toProperCase()}`}
                          </div>
                        )}
                        {item?.product_type !== 'STORABLE' && (
                          <div
                            className="create-pr__product-name__suggestion-item__type"
                            style={{
                              backgroundColor: Helpers.getProductType(item?.product_type).color,
                            }}
                          >
                            {Helpers.getProductType(item?.product_type).text}
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ ProductReducers, UserReducers }) => ({
  products: ProductReducers.products,
  user: UserReducers.user,
  searchProductsLoading: ProductReducers.searchProductsLoading,
  searchResults: ProductReducers.searchResults,
});

const mapDispatchToProps = (dispatch) => ({
  searchProducts: (params) => dispatch(ProductActions.searchProducts(params)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search)),
});

TenantSkuFilter.propTypes = {
  products: PropTypes.any,
  record: PropTypes.any,
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  getProducts: PropTypes.func,
  user: PropTypes.any,
  disabled: PropTypes.bool,
  showError: PropTypes.any,
  isTextarea: PropTypes.bool,
  onClear: PropTypes.func,
  tenantDepartmentId: PropTypes.any,
  onlyBatches: PropTypes.bool,
  excludeOutOfStock: PropTypes.bool,
  isSalesProduct: PropTypes.bool,
  isPurchaseProduct: PropTypes.bool,
  showClear: PropTypes.bool,
  includeService: PropTypes.bool,
  excludeService: PropTypes.bool,
  excludedBundledProducts: PropTypes.bool,
  excludedProducts: PropTypes.any,
  excludedNonStorableProducts: PropTypes.any,
  includeBundle: PropTypes.any,
  selectedTenant: PropTypes.any,
  isMarketplaceSeller: PropTypes.any,
  productType: PropTypes.any,
  searchProducts: PropTypes.func,
  searchProductsLoading: PropTypes.bool,
  searchResults: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TenantSkuFilter));
